/**
 * Theme configuration
 *
 * This file isolates the theme configuration from aws-exports.js to avoid
 * importing sensitive data into components that only need the theme name.
 */

import type { AwsConfig } from '../types/config';

import awsConfig from './aws-exports';

// Cast to our interface to handle optional properties
const config = awsConfig as AwsConfig;

// Export theme name and theme toggle flag
export const themeName = config.theme;
// showThemeToggle defaults to false if not present in config (backward compatible)
export const showThemeToggle = config.showThemeToggle ?? false;
